import Globalize from "globalize";
import { TotalTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";
import { safeParseFloat } from "lib/number";
import { MetricsKind } from "helpers/metrics/types";

export const parseReviewPlanValue = (value: number | string, type: TotalTypes): string | number => {
    let planValue: string | number = safeParseFloat(Globalize.numberParser()(`${value}`), 0);
    switch (type) {
        case TotalTypes.Retail:
        case TotalTypes.Wholesale:
        case TotalTypes.AvgRetail:
        case TotalTypes.AvgWholesale:
        case TotalTypes.Depth:
            // BE needs decimal to be string
            planValue = planValue ? planValue.toString() : "";
            break;
        case TotalTypes.Skus:
        case TotalTypes.Units:
            planValue = Math.round(planValue);
            break;
        default:
    }
    return planValue;
};

export const parseMetricReviewPlanValue = (value: number | string, kind: MetricsKind): string | number => {
    let planValue: string | number = safeParseFloat(Globalize.numberParser()(`${value}`), 0);
    switch (kind) {
        case MetricsKind.AVERAGE_UNITS:
        case MetricsKind.BREADTH_PERCENTAGE_PLAN:
        case MetricsKind.DOOR_PERCENTAGE_PLAN:
        case MetricsKind.UNIT_DOOR_PERCENTAGE_PLAN:
        case MetricsKind.ROW_PERCENTAGE_PLAN:
        case MetricsKind.UNIT_ROW_PERCENTAGE_PLAN:
            break;
        case MetricsKind.AUR:
        case MetricsKind.TOTAL_RETAIL:
        case MetricsKind.TOTAL_COST:
        case MetricsKind.UNITS:
        case MetricsKind.PLAN_ROWS:
        case MetricsKind.STORE_WITH_UNITS:
            planValue = Math.round(planValue);
            break;
        default:
    }
    return planValue;
};
